import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1f580f2a&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=1f580f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f580f2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f580f2a')) {
      api.createRecord('1f580f2a', component.options)
    } else {
      api.reload('1f580f2a', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=1f580f2a&scoped=true&", function () {
      api.rerender('1f580f2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/olap-reports/components/list.vue"
export default component.exports